import { atom } from "recoil";
// 다른 컴포넌트의 체크 여부 관리
export const itemReportListState = atom({
    key: 'itemReportListState',
    // key의 값은 항상 고유값이어야 합니다.
    default: [],
});
